import { Component, OnDestroy, OnInit, HostBinding, HostListener, ViewEncapsulation, Injector, ChangeDetectorRef } from "@angular/core";
import { MediaObserver } from '@ngbracket/ngx-layout';

// import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { AuthenticationService } from 'app/main/auth/service';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { CoreConfigService } from '@core/services/config.service';
import { CoreMediaService } from '@core/services/media.service';
import { Router } from '@angular/router';
import { LocalStorageKeys, ngbModalOptions } from '@shared/default-values';
import { UserModel } from 'app/main/auth/models';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from '@shared/services';
import { BaseComponent } from '@shared/base/base.component';
import { ChangePasswordValidator } from 'app/main/auth/validators/change-password.validation';
import { ProfileController } from 'app/main/auth/controllers/ProfileController';
import { FilesController } from 'app/main/catalog/FilesController';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NavbarComponent extends BaseComponent implements OnInit, OnDestroy {
  public horizontalMenu: boolean;
  public hiddenMenu: boolean;

  public coreConfig: any;
  public currentSkin: string;
  public prevSkin: string;

  public currentUser: UserModel;
  logo = 'assets/images/users/user-dummy-img.jpg';
  public languageOptions: any;
  public navigation: any;
  public selectedLanguage: any;

  @HostBinding('class.fixed-top')
  public isFixed = false;

  @HostBinding('class.navbar-static-style-on-scroll')
  public windowScrolled = false;
  imageUrl: void;

  // Add .navbar-static-style-on-scroll on scroll using HostListener & HostBinding
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) &&
      this.coreConfig.layout.navbar.type == 'navbar-static-top' &&
      this.coreConfig.layout.type == 'horizontal'
    ) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }

  // Private
  private _unsubscribeAll: Subject<void>;


  // change password
  public existPasswordTextType: boolean;
  public newPasswordTextType: boolean;
  public confirmPasswordTextType: boolean;
  errorMsg: string = null;
  errorMsgExistingPass: string = null;
  errorMsgNewPass: string = null;
  existPassInValid = false;
  newPassInValid = false;
  confirmPassInValid = false;

  public changePasswordForm: UntypedFormGroup;

  constructor(public injector: Injector,
    private _router: Router,
    private _coreConfigService: CoreConfigService,
    private _coreMediaService: CoreMediaService,
    private _coreSidebarService: CoreSidebarService,
    private _mediaObserver: MediaObserver,
    public _translateService: TranslateService,
    private modalService: NgbModal,
    private _formBuilder: UntypedFormBuilder,
    private _toasterService: ToastrService,
    private _authenticationService: AuthenticationService,
    private _notificationService: NotificationService,
    private _cdr: ChangeDetectorRef
  ) {
    super(injector);
    this._authenticationService.currentUser$.subscribe(x => (this.currentUser = x));

    this.languageOptions = {
      en: {
        title: 'English',
        flag: 'us'
      },
      fr: {
        title: 'French',
        flag: 'fr'
      },
      de: {
        title: 'German',
        flag: 'de'
      },
      pt: {
        title: 'Portuguese',
        flag: 'pt'
      }
    };

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  toggleSidebar(key): void {
    this._coreSidebarService.getSidebarRegistry(key).toggleOpen();
  }

  setLanguage(language): void {
    this.selectedLanguage = language;
    this._translateService.use(language);

    this._coreConfigService.setConfig({ app: { appLanguage: language } }, { emitEvent: true });
  }

  toggleDarkSkin() {
    this._coreConfigService
      .getConfig()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(config => {
        this.currentSkin = config.layout.skin;
      });

    // Toggle Dark skin with prevSkin skin
    this.prevSkin = localStorage.getItem('prevSkin');

    if (this.currentSkin === 'dark') {
      this._coreConfigService.setConfig(
        { layout: { skin: this.prevSkin ? this.prevSkin : 'default' } },
        { emitEvent: true }
      );
    } else {
      localStorage.setItem('prevSkin', this.currentSkin);
      this._coreConfigService.setConfig({ layout: { skin: 'dark' } }, { emitEvent: true });
    }
  }

  logout() {
    this._authenticationService.logout();
    this._router.navigate(['/auth/login']);
  }
  getImage(url: string) {
    this.httpService.Download(url)?.subscribe((response: Blob) => {
      this.convertBlobToBase64(response);
    });
  }

  convertBlobToBase64(blob: Blob): void {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      let imageElem = document.getElementById('logo-image') as any;
      if (imageElem) {
        imageElem.src = reader.result as string;
      }
    };
  }
  ngAfterViewInit(): void {
    if (this._authenticationService.currentUser?.imageUrl) {
      this.getImage(FilesController.GetFile(this._authenticationService.currentUser?.imageUrl))
    }
  }

  ngOnInit(): void {
    this.initiatForm();
    // get the currentUser details from localStorage
    this.currentUser = JSON.parse(localStorage.getItem(LocalStorageKeys.User));

    // Subscribe to the config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
      this.horizontalMenu = config.layout.type === 'horizontal';
      this.hiddenMenu = config.layout.menu.hidden === true;
      this.currentSkin = config.layout.skin;

      // Fix: for vertical layout if default navbar fixed-top than set isFixed = true
      if (this.coreConfig.layout.type === 'vertical') {
        setTimeout(() => {
          if (this.coreConfig.layout.navbar.type === 'fixed-top') {
            this.isFixed = true;
          }
        }, 0);
      }
    });

    // Horizontal Layout Only: Add class fixed-top to navbar below large screen
    if (this.coreConfig.layout.type == 'horizontal') {
      // On every media(screen) change
      this._coreMediaService.onMediaUpdate.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
        const isFixedTop = this._mediaObserver.isActive('bs-gt-xl');
        if (isFixedTop) {
          this.isFixed = false;
        } else {
          this.isFixed = true;
        }
      });
    }

    // Set the selected language from default languageOptions
    // this.selectedLanguage = _.find(this.languageOptions, {
    //   id: this._translateService.currentLang
    // });
  }
  private initiatForm() {
    this.changePasswordForm = this._formBuilder.group({
      existingPassword: new UntypedFormControl(
        null,
        ChangePasswordValidator.oldPassword
      ),
      newPassword: new UntypedFormControl(null, ChangePasswordValidator.newPassword),
      confirmPassword: new UntypedFormControl(
        null,
        ChangePasswordValidator.confirmPassword
      ),
    });

    this.changePasswordForm.controls["existingPassword"].valueChanges.subscribe(
      (res) => {
        this.errorMsgExistingPass = null;
        this.existPassInValid =
          this.changePasswordForm.controls["existingPassword"].invalid;
      }
    );

    this.changePasswordForm.controls["newPassword"].valueChanges.subscribe(
      (res) => {
        this.errorMsgNewPass = null;
        this.newPassInValid =
          this.changePasswordForm.controls["newPassword"].invalid;
      }
    );

    this.changePasswordForm.controls["confirmPassword"].valueChanges.subscribe(
      (res) => {
        this.confirmPassInValid =
          this.changePasswordForm.controls["confirmPassword"].invalid;
      }
    );
  }

  onSubmit() {
    // stop here if form is invalid
    if (this.changePasswordForm.invalid ||
      (this.changePasswordForm.getRawValue().confirmPassword != this.changePasswordForm.getRawValue().newPassword
        && !this.changePasswordForm.get('confirmPassword').errors
        && !this.changePasswordForm.get('newPassword').errors)) {
      this.changePasswordForm.markAllAsTouched();
      return;
    }

    let body = this.changePasswordForm.getRawValue();

    this.httpService.POST(ProfileController.ChangePassword, body).subscribe(
      (res) => {
        this.modalService.dismissAll();

        this._notificationService
          .info(
            "Your password has been changed successfully. To ensure the security of your account, you will be automatically logged out. Please log back in using your new password to continue accessing our website",
            ""
          )
          .then((x) => {
            this._toasterService.success(
              "Password successfully reset."
            );
            this._authenticationService.logout();
          });
      },
      (err) => {
        this.errorMsg = this.getErrorMsg(err);
        switch (this.errorMsg) {
          case "Existing password not correct.":
            this.errorMsgExistingPass = this.errorMsg;
            this.errorMsg = null;
            break;

          case "Password has been used before.":
            this.errorMsgNewPass = this.errorMsg;
            this.errorMsg = null;
            break;

          case "Your password mustn't contain 5 or more repeated character":
            this.errorMsgNewPass = this.errorMsg;
            this.errorMsg = null;
            break;
        }
      }
    );
  }

  detectFormControl(formControl: string) {
    this.changePasswordForm.controls[formControl].markAsTouched();
    this._cdr.detectChanges();
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  onChangePassword(modalInfo) {

    this.modalService.open(modalInfo, {
      ...ngbModalOptions,
      centered: true,
      size: 'md',
      windowClass: 'modal modal-primary'
    });
  }

  cancel() {
    this.changePasswordForm.reset();
    this.modalService.dismissAll();
    this.errorMsg = null;
    this.errorMsgExistingPass = null;
    this.errorMsgNewPass = null;
    this.existPassInValid = false;
    this.newPassInValid = false;
    this.confirmPassInValid = false;
    this._cdr.detectChanges();
  }

  toggleNewPasswordTextType() {
    this.newPasswordTextType = !this.newPasswordTextType;
  }

  toggleExistPasswordTextType() {
    this.existPasswordTextType = !this.existPasswordTextType;
  }

  toggleConfirmPasswordTextType() {
    this.confirmPasswordTextType = !this.confirmPasswordTextType;
  }

  checkExistPass() {
    this.existPassInValid = this.changePasswordForm.controls["existingPassword"].invalid;
  }

  checkNewtPass() {
    this.newPassInValid = this.changePasswordForm.controls["newPassword"].invalid;
  }

  checkConfirmPass() {
    this.confirmPassInValid = this.changePasswordForm.controls["confirmPassword"].invalid;
  }
}
